import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from '../../language/en.json';
import vi from '../../language/vi.json';
import adminEn from '../../language/admin.en.json';
import adminVi from '../../language/admin.vi.json';

export const SUPPORTED_LANGUAGES = ['vi', 'en'] as const;
export type AppLanguage = (typeof SUPPORTED_LANGUAGES)[number];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { ...en, admin: adminEn },
      vi: { ...vi, admin: adminVi },
    },
    fallbackLng: 'vi',
    supportedLngs: [...SUPPORTED_LANGUAGES],
    defaultNS: 'auth',
    ns: ['auth', 'common', 'nav', 'profile', 'admin'],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },
  });

export default i18n;
